import {
	type BackendPlacementMessage,
	type FrontendPlacementMessage,
	noValidation,
} from '@post-office/placement-common-v2';
import type {
	AnyPayload,
	CreatePlacementMessageConfig,
} from '@post-office/message-template-contracts/placement-v2';
import {
	type AnyBackendMessageStage,
	type AnyFrontendStage,
	type BackendSyncMessageStage,
} from '@post-office/placement-common-v2/create-placement/types';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';
import { type TransformMetadataResult } from '@post-office/shared-contracts/message-template-metadata';

// assertMessageTemplateContext is a validation file created by Post Office's validation library Vindicated. It will be included when you create your message template. You can find out more about vindicated here: https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/vindicated-validation-library/#vindicated:-post-office's-runtime-type-validation-library

import { type MessageTemplateContext } from '../../..';
import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import { NonMauChatCtaMessage } from '../../../common/components/NonMauChatCtaMessage';

export const MessageBackend: (config: CreatePlacementMessageConfig) => BackendPlacementMessage<{
	transformMetadata: BackendSyncMessageStage<AnyPayload, TransformMetadataResult>;
	hydrate?: AnyBackendMessageStage;
}> = PlacementBackend.createMessageBackend(() => ({
	transformMetadata: {
		validate: assertMessageTemplateContext,
		stage: () => ({}),
	},
}));

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageTemplateContext>(),
		Component: ({ handleOnDismissed }: { handleOnDismissed: () => void }) => {
			return (
				<NonMauChatCtaMessage
					handleOnDismissed={handleOnDismissed}
					context={{
						source: 'confluence-side-nav',
					}}
				/>
			);
		},
	},
});
